import { createReducer, INITIAL_STATE } from '@shared/redux';

export const SUBMIT_CHANGE_PAYMENT_METHOD = '@billing/payment-method/SUBMIT_CHANGE_PAYMENT_METHOD';
export const SET_SUBMIT_CHANGE_PAYMENT_METHOD_FLAGS = '@billing/payment-method/SET_SUBMIT_CHANGE_PAYMENT_METHOD_FLAGS';

export const getSubmitChangePaymentMethodFlags = state => state
    .billing.paymentMethod.submitChangePaymentMethod.flags;

export const submitChangePaymentMethod = paymentMethodId => ({
    type: SUBMIT_CHANGE_PAYMENT_METHOD,
    payload: {
        paymentMethodId,
    },
});

export const setSubmitChangePaymentMethodFlags = ({ hasBillingDetails }) => ({
    type: SET_SUBMIT_CHANGE_PAYMENT_METHOD_FLAGS,
    payload: {
        flags: {
            hasBillingDetails,
        },
    },
});

export interface PaymentMethodState {
    submitChangePaymentMethod: {
        flags: {
            hasBillingDetails: boolean;
        }
    }
}

const initialValue: PaymentMethodState = {
    submitChangePaymentMethod: {
        flags: {
            hasBillingDetails: false,
        },
    },
};

export const paymentMethodReducer = createReducer({
    [INITIAL_STATE]: initialValue,
    [SET_SUBMIT_CHANGE_PAYMENT_METHOD_FLAGS]: (state, action) => ({
        ...state,
        submitChangePaymentMethod: {
            flags: {
                ...state.submitChangePaymentMethod.flags,
                ...action.payload.flags,
            },
        },
    }),
});
